// src/pages/company/view.js

import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'

const ViewCompany = () => {
  const { id } = useParams()
  const [company, setCompany] = useState(null)
  const [loading, setLoading] = useState(true)
  const fetchCompanyData = async () => {
    try {
      const response = await axiosAuthInstance.get(`company/detail/${id}`)
      setCompany(response.data.result)
    } catch (error) {
      console.error('Error fetching company data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCompanyData()
  }, [id])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!company) {
    return <div>No company data found.</div>
  }

  return (
    <div className='p-4'>
      <div className='bg-white shadow-md rounded-lg p-6'>
        <h2 className='text-xl font-semibold mb-2'>Company Details</h2>
        <div>
          <table className='table-auto w-full border-collapse'>
            <tbody>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Category</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.category.name}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Type</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.type.name}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Company Name</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.name}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Year of Establishment</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.year_of_est}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Registration</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.registration}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Founder</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.founder}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Contact Person</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.contact_person}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Contact Person Role </strong>
                </td>
                <td className='border-b px-4 py-2'>
                  {company.contact_person_role.name}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Account Number</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.account_number}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>IFSC</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.ifsc}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Pan Number</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.pan_number}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>Pan Image</strong>
                </td>
                <td className='border-b px-4 py-2'>
                  {company.pan_image ? (
                    <img
                      src={company.pan_image}
                      alt='Company'
                      className='my-2 w-32 h-32 object-contain'
                    />
                  ) : (
                    <span>No photo available</span>
                  )}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>GST Number</strong>
                </td>
                <td className='border-b px-4 py-2'>{company.gst_number}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2'>
                  <strong>GST Image</strong>
                </td>
                <td className='border-b px-4 py-2'>
                  {company.gst_image ? (
                    <img
                      src={company.gst_image}
                      alt='ID Proof'
                      className='my-2  w-32 h-32 object-contain'
                    />
                  ) : (
                    <span>No ID proof available</span>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ViewCompany
